// extracted by mini-css-extract-plugin
export default {"pricingInput":"DeviceSize_pricingInput__HjYPW"};